import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, Util} from '../../../app/util';
import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {
    TAction,
    TFinanceSide,
    TConsumoFlag,
    TAcessoFind,
} from "../../../app/enum";
import {ModalActionPage} from "../modal-action/modal-action";
import {WebstorOpenPage} from "../webstor-open/webstor-open";
import {PaybookRepo} from '../../../repositories/payment-repo';


@Component({
    selector: 'page-consumo-edit',
    templateUrl: 'consumo-edit.html',
    providers: [ProfileService, HotspotService, PaybookRepo]
})
export class ConsumoEditPage {

    TConsumoFlag: any = TConsumoFlag;

    config: any;
    logado: any;

    userset: any;
    paybook: any;
    olhaapp: boolean;

    indexCS: number;

    etapa: number;

    hotspotID: number;
    monitorBool: boolean;

    detalheBool: boolean;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public hotspotService: HotspotService,
                public viewCtrl: ViewController, public util: Util,
                public logadoService: LogadoService,
                public paybookRepo: PaybookRepo) {


        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.userset = this.navParams.get('userset');
        this.paybook = this.navParams.get('paybook');
        this.olhaapp = this.navParams.get('olhaapp');
        this.indexCS = this.navParams.get('indexCS');

        this.hotspotID = this.navParams.get('hotspotID');
        let paybookID = this.navParams.get('paybookID');

        this.monitorBool = this.navParams.get('monitorBool');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Consumo Edit', '/consumo-edit');

        if (this.etapa == 0 && paybookID) this.paybookLoad(paybookID);

    }




    /** ************************************************ PAYBOOK ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    getTitle() {

        if (this.etapa == 0) return 'Consumo';
        if (this.etapa == 1) return (this.paybook.Consumos[this.indexCS].Blended ? this.paybook.Consumos[this.indexCS].Blended.BlendedNome + ' ' : '') + this.paybook.Consumos[this.indexCS].Produto.ProdutoNome;

    }

    consumoTint() {

        let consumo = null;
        let consumoRead = (this.paybook && this.paybook.Consumos);
        if (consumoRead) consumo = this.paybook.Consumos[this.indexCS];
        let canflag = (consumo ? consumo.Consumo.ConsumoFlag : TConsumoFlag.cfLancado);

        if (this.etapa == 0) return this.paybook.Branded.BrandedCora;
        if (this.etapa == 1) return (canflag == TConsumoFlag.cfDevolve ? 'CorFire' : (canflag == TConsumoFlag.cfPerdido ? 'CorPuta' : 'CorMenu'));

    }

    paybookLoad(paybookID) {

        //DESK
        if (!this.olhaapp) {
            let onLoad = (data) => {
                if (!this.paybook) this.paybook = data.Comandas[0];
                else this.util.clearObj(this.paybook, [], data.Comandas[0]);
            };
            let params = '&ComandaText=' + paybookID + '&ComandaMode=' + TAcessoFind.afFindID + '&DetalheBool=' + this.detalheBool;
            this.monitorDesk('DESK-Comanda', TAction.acInfo, params, null, onLoad);
            return;
        }

        //SYNC - Bridging...
        if (!this.olhaapp) {
            this.hotspotService.paybook(TAction.acBook, paybookID)
                .subscribe(
                    data => {
                        if (!data.Paybooks || !data.Paybooks[0]) {
                            this.util.toastSimply('Paybook não encontrado', 3000, () => this.dismiss());
                            return;
                        }

                        data.Paybooks[0].PaybookDate = data.Paybooks[0].PaybookCria.split(' ')[0];
                        this.paybook = data.Paybooks[0];
                    },
                    erro => this.util.alertResult(erro, () => this.dismiss())
                );
        }

    }

    monitorDesk(document, action, params, json, onSave) {

        let hotspotID = (this.hotspotID ? this.hotspotID : (this.paybook ? this.paybook.HotspotID : 0));

        let loading = this.util.loadingDots();
        loading.present();

        this.util.monitorDesk(this.monitorBool, document, hotspotID, params, action, json)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onSave(data),
                erro => this.util.alertResult(erro));

    }





    /** ************************************************ CONSUMO ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    cancelaText() {

        let consumo = this.paybook.Consumos.filter(CS => !!CS.Consumo.ConsumoBola)[0];
        return (!consumo || consumo.Consumo.ConsumoFlag == TConsumoFlag.cfLancado ? 'Cancelar' : 'Restaurar');

    }

    cancelaBool(rowline): boolean {

        let consumo = this.paybook.Consumos.filter(CS => !!CS.Consumo.ConsumoBola)[0];
        if (!consumo) return true;

        return (consumo.Consumo.ConsumoFlag == TConsumoFlag.cfLancado &&
                rowline.Consumo.ConsumoFlag == TConsumoFlag.cfLancado)
                ||
                (consumo.Consumo.ConsumoFlag != TConsumoFlag.cfLancado &&
                rowline.Consumo.ConsumoFlag != TConsumoFlag.cfLancado);

    }

    consumoFlug(flug: 'tint' | 'text' | 'icon') {

        let consumo = this.paybook.Consumos[this.indexCS];
        let canflag = consumo.Consumo.ConsumoFlag;
        let cancela = (canflag > TConsumoFlag.cfLancado);

        if (flug == 'tint') return (canflag == TConsumoFlag.cfDevolve ? 'CorFire' : (canflag == TConsumoFlag.cfPerdido ? 'CorPuta' : 'CorMenu'));
        if (flug == 'text') return (cancela && consumo.Justify ? 'Motivo: ' + consumo.Justify.JustifyNome : 'Lançado');
        if (flug == 'icon') return (cancela && consumo.Justify ? consumo.Justify.JustifyIcon : 'b-icon-ok');

    }

    consumoSoma(flug: 'cash' | 'text' | 'info' | 'desc') {

        let consumo = this.paybook.Consumos[this.indexCS];
        let booldeb = (this.paybook.FinanceSide == TFinanceSide.cdDebito);

        if (flug == 'cash') return this.util.dinheiro(this.paybookRepo.consumoDebt(this.paybook, this.indexCS));
        if (flug == 'info') return this.util.dinheiro(consumo.Consumo.ConsumoQtde * consumo.Consumo.ConsumoCash);
        
        //SYNC
      //if (flug == 'text') return (!booldeb ? '' : consumo.Consumo.ConsumoPack  + 'pk • ') + 'x' + this.util.numerico(consumo.Consumo.ConsumoQtde) + ' • ' + this.util.dinheiro(consumo.Consumo.ConsumoCash - consumo.Consumo.ConsumoLess);
        //DESK
        if (flug == 'text') return (!booldeb ? '' : consumo.Consumo.ConsumoPack  + 'pk • ') + 'x' + this.util.numerico(consumo.Consumo.ConsumoQtde) + ' • ' + this.util.dinheiro((consumo.Consumo.ConsumoQtde * consumo.Consumo.ConsumoCash) - consumo.Consumo.ConsumoLess);
        
      
        //SYNC
      //if (flug == 'desc') return this.util.rule3(consumo.Consumo.ConsumoQtde * consumo.Consumo.ConsumoCash, 100, consumo.Consumo.ConsumoQtde * consumo.Consumo.ConsumoLess) + '% • ' + this.util.dinheiro(consumo.Consumo.ConsumoQtde * consumo.Consumo.ConsumoLess);
        //DESK
        if (flug == 'desc') return this.util.rule3(consumo.Consumo.ConsumoQtde * consumo.Consumo.ConsumoCash, 100,                               consumo.Consumo.ConsumoLess) + '% • ' + this.util.dinheiro(consumo.Consumo.ConsumoLess);

    }

    conviteItem() {

        let consumos = this.paybook.Consumos;
        if (!consumos || !consumos.length) return null;

        let index = consumos.findIndex(CS => CS.Produto.ProdutoID == 100000000);
        if (index >= 0) index = 0;
        
        return consumos[index];

    }

    consumoEdit() {

        let consumo = this.paybook.Consumos[this.indexCS];
        let params = '&ConsumoID=' + consumo.ConsumoID;

        //#MONITOR-LOCAL
        let onSave = () => this.dismiss();
        this.monitorDesk('DESK-Consumo', TAction.acEdit, params, consumo, onSave);
        return;



        //#BRIDGE
        // let loading = this.util.loadingDots();
        // loading.present();

        // this.hotspotService.consumo(TAction.acEdit, this.paybook.PaybookID, consumo)
        //     .finally(() => loading.dismiss())
        //     .subscribe(
        //         data => this.dismiss(),
        //         erro => this.util.alertResult(erro)
        //     );

    }

    tecladoOpen(text: 'PACK' | 'QTDE' | 'LESS') {

        let consumo = this.paybook.Consumos[this.indexCS];

        let onOkey = (okey, that, data) => {

            let value = this.util.currency(okey.inputf.text);

            if (text == 'PACK' || text == 'QTDE') {
                consumo.Consumo.ConsumoQtde = value;
                that.dismiss(); //this.consumoSave();
            }

            if (text == 'LESS') {
                this.consumoLess(value, 0, that);
            }

        };

        let bool = (text == 'LESS');
        let info = (text == 'LESS' ? 'VALOR COBRAR' : text);
        let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'servico', onOkey, null, bool, info)};
        this.util.modalopen(ModalActionPage, 'full', false, objectData).subscribe();

    }

    alterarOpen() {

        /** OPEN **/
        let booldeb = (this.paybook.FinanceSide == TFinanceSide.cdDebito);
        let buttons: Array<any> = [];
        if (booldeb)                          buttons.push({text: 'Pack',     handler: () => this.consumoPack()});
        if (!this.logado.Profile.ProfileZito) buttons.push({text: 'Qtde',     handler: () => this.consumoQtde()});
                                              buttons.push({text: 'Desconto', handler: () => this.consumoCent()});
        this.util.sheetOpen(buttons, 'ALTERAR', 0);
        
    }

    consumoPack() {

        let consumo = this.paybook.Consumos[this.indexCS];

        let onQtde = (qtde) => {
            if (qtde == 'Digitar') {
                this.tecladoOpen('PACK');
                return;
            }
            consumo.Consumo.ConsumoPack = parseInt(qtde);
            this.consumoEdit();
        };

        let buttons: Array<any> = [];
        buttons.push({text: 'Digitar', value: 'Digitar'});
        for (let i = 1; i <= 100; i++) buttons.push({text: i, value: i});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = consumo.Consumo.ConsumoQtde;
        this.util.pickerOpen(columns, onQtde);

    }

    consumoQtde() {

        let consumo = this.paybook.Consumos[this.indexCS];

        let onQtde = (qtde) => {
            if (qtde == 'Digitar') {
                this.tecladoOpen('QTDE');
                return;
            }
            consumo.Consumo.ConsumoQtde = parseFloat(qtde);
            this.consumoEdit();
        };

        let buttons: Array<any> = [];
        buttons.push({text: 'Digitar', value: 'Digitar'});
        for (let i = 1; i <= 100; i++) buttons.push({text: i, value: i});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = consumo.Consumo.ConsumoQtde;
        this.util.pickerOpen(columns, onQtde);

    }

    consumoBall() {

        let consumoID = '';
        this.paybook.Consumos.forEach(CS => {
            if (CS.Consumo.ConsumoBola) consumoID = consumoID + (consumoID == '' ? '' : ',') + CS.Consumo.ConsumoID;
        });

        return consumoID;

    }

    consumoBola(bola: boolean) {

        this.paybook.Consumos.forEach(CS => {
            if (CS.Consumo.ConsumoFlag == TConsumoFlag.cfLancado && CS.Produto.ProdutoID != 100000000) {
                CS.Consumo.ConsumoBola = bola;
            }
        });

    }

    consumoCalc(tipo: 'Soma' | 'Desc' | 'Bola') {

        let item = 0;
        this.paybook.Consumos.forEach(CS => {
            if (CS.Consumo.ConsumoFlag == TConsumoFlag.cfLancado) {
                if (tipo == 'Soma'                          ) item = item + (CS.Consumo.ConsumoQtde * CS.Consumo.ConsumoCash) + CS.Consumo.ConsumoMore - CS.Consumo.ConsumoLess;
                if (tipo == 'Desc' && CS.Consumo.ConsumoLess) item = item + CS.Consumo.ConsumoLess;
                if (tipo == 'Bola' && CS.Consumo.ConsumoBola) item = item + (CS.Consumo.ConsumoQtde * CS.Consumo.ConsumoCash) + CS.Consumo.ConsumoMore - CS.Consumo.ConsumoLess;
            }
        });

        return item;

    }

    consumoFlag() {

        if (this.etapa == 1) this.paybook.Consumos[this.indexCS].Consumo.ConsumoBola = true;

        let consumos = this.paybook.Consumos.filter(CS => !!CS.Consumo.ConsumoBola);
        let consumoID = this.consumoBall();
        if (!consumoID) {
            this.util.toastSimply('Selecione o produto ou serviço');
            return;
        }

        let onDone = (flag, just) => {
    
            //#MONITOR-LOCAL
            let onSave = () => {
            
                consumos.forEach(CS => {
                    CS.Consumo.ConsumoFlag = flag;
                    CS.Justify = just;
                });

                this.dismiss();

            }

            let justifyID = (just ? just.JustifyID : 0);
            let params = '&ConsumoID=' + consumoID + '&JustifyID=' + justifyID + '&ConsumoFlag=' + flag;
            this.monitorDesk('DESK-Consumo', TAction.acFlag, params, null, onSave);
    
        };

        let onFlag = (flag) => {
            let object = {homeb: false, etapa: 1, title: 'CANCELAMENTO', keyname: 'Justify', toggler: null, monitorBool: this.monitorBool, consumoFlag: flag};
            this.util.modalopen(WebstorOpenPage, 'alto', false, object).subscribe(data => onDone(flag, data));
        }

        if (consumos[0].Consumo.ConsumoFlag == TConsumoFlag.cfLancado) {
            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Perda',     handler: () => onFlag(TConsumoFlag.cfPerdido)});
            buttons.push({text: 'Devolução', handler: () => onFlag(TConsumoFlag.cfDevolve)});
            this.util.sheetOpen(buttons, 'CANCELAR', 0);
            return;
        }

        onDone(TConsumoFlag.cfLancado, null);

    }

    consumoMove() {

        let consumoID = this.consumoBall();
        if (!consumoID) {
            this.util.toastSimply('Selecione o produto ou serviço');
            return;
        }

        let onOkey = (okey, that, data) => {

            let comandaNoro = parseInt(okey.inputf.text);

            if (this.paybook.PaybookNoro == comandaNoro) {
                this.util.toastSimply('Produto está nessa comanda, informe a comanda de destino');
                return;
            }
    
            let onMove = () => {
                that.dismiss();
                this.dismiss();
            }

            this.monitorDesk('DESK-Consumo', TAction.acMove, '&ConsumoID=' + consumoID + '&ComandaSend=' + comandaNoro, null, onMove);

        };

        let objectData = {modalinfo: this.config.modalinfo(this.util, 'consumoMove', onOkey)};
        this.util.modalopen(ModalActionPage, 'alto', false, objectData).subscribe();

    }

    consumoLess(consumoLess, consumoCent, that) {

        if (this.etapa == 1) this.paybook.Consumos[this.indexCS].Consumo.ConsumoBola = true;

        let consumos = this.paybook.Consumos.filter(CS => !!CS.Consumo.ConsumoBola);
        let consumoID = this.consumoBall();
        if (!consumoID) {
            this.util.toastSimply('Selecione o produto ou serviço');
            return;
        }

        let onDone = (just) => {

            //#MONITOR-LOCAL
            let onSave = () => {

                consumos.forEach(CS => {

                    let consumoCalc = 0;
                    
                    if (consumoLess > 0) {
                        //DEVELOP - Rateio desconto
                        consumoCalc = (CS.Consumo.ConsumoQtde * CS.Consumo.ConsumoCash) - consumoLess;
                    }

                    if (consumoLess == 0) {
                        //SYNC
                      //consumoCalc = (CS.Consumo.ConsumoCash * (consumoCent/100));
                        //DESK
                        consumoCalc = (CS.Consumo.ConsumoQtde * CS.Consumo.ConsumoCash) * (consumoCent/100);
                        consumoCalc = parseFloat('' + consumoCalc.toFixed(2));
                    }
                    
                    CS.Consumo.ConsumoLess = consumoCalc;
                    CS.Justify = just;

                });

                this.dismiss();

            }

            let justifyID = (just ? just.JustifyID : 0);
            let params = '&ConsumoID=' + consumoID + '&JustifyID=' + justifyID + '&ConsumoLess=' + consumoLess + '&ConsumoCent=' + consumoCent;
            this.monitorDesk('DESK-Consumo', TAction.acLess, params, null, onSave);
    
        };

        if (consumoLess || consumoCent) {
            let object = {homeb: false, etapa: 1, title: 'DESCONTO', keyname: 'Justify', toggler: null, monitorBool: this.monitorBool, consumoFlag: TConsumoFlag.cfLancado};
            this.util.modalopen(WebstorOpenPage, 'alto', false, object).subscribe(data => onDone(data));
            if (that) setTimeout(() => that.dismiss());
            return;
        }

        onDone(null);
        if (that) that.dismiss();

    }

    consumoCent() {

        if (this.etapa == 1) this.paybook.Consumos[this.indexCS].Consumo.ConsumoBola = true;

        let consumos = this.paybook.Consumos.filter(CS => !!CS.Consumo.ConsumoBola);
        let consumoID = this.consumoBall();
        if (!consumoID) {
            this.util.toastSimply('Selecione o produto ou serviço');
            return;
        }

        let onSave = (cent) => {
            if (cent == 'Digitar') {
                this.tecladoOpen('LESS');
                return;
            }
            this.consumoLess(0, cent, null);
        };

        let ipos = 0;
        let cash = 0;
        consumos.forEach(CS => cash += (CS.Consumo.ConsumoQtde * CS.Consumo.ConsumoCash));

        let buttons: Array<any> = [];
        buttons.push({text: 'Preço Normal', value: 0});
        for (let i = 5; i <= 100; i = i + 5) {
            let full = cash - (cash * (i/100));
            full = parseFloat('' + full.toFixed(2));

            //SYNC
          //let loop = (consumos[0].Consumo.ConsumoCash * (i/100));
            
            //DESK
            let loop = (consumos[0].Consumo.ConsumoQtde * consumos[0].Consumo.ConsumoCash) * (i/100);

            loop = parseFloat('' + loop.toFixed(2));
            if (consumos[0].Consumo.ConsumoLess == loop) ipos = (i/5);

            buttons.push({text: i + '%  • ' + this.util.dinheiro(full), value: i});
        }
        buttons.push({text: 'Digitar', value: null});

        let columns = [];
        columns.push({name: 'root', options: buttons});
        columns[0].selectedIndex = ipos;
        this.util.pickerOpen(columns, onSave);

    }


    dismiss() {

        // Etapa 1 e 2 - Zera seleção!
        this.paybook.Consumos.forEach(CS => delete CS.Consumo.ConsumoBola);

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss({}, 'back');
            return;
        }

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/consumo-edit/consumo-edit.ts